import React, { FC, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import posthog from 'posthog-js';
import { isUserManagedBySupplier, PERMISSION_NAMES } from '../../utils/AuthUtils';
import { COMPLIANCE_FEATURE_FLAG } from '../compliance_common/ComplianceConstants';
import OverviewShell from '../overview_shell/OverviewShell';

require('./SuppliersOverviewPage.less');

const SuppliersOverviewPage: FC<any> = ({
	history,
	userType,
	childRoutes,
	currentUser,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/${userType}/suppliers/overview/${key}`),
		[history, userType]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const isNotSupplierManaged = useMemo(() => !isUserManagedBySupplier(currentUser), []);

	const tabs = [
		{
			key: 'privateNetwork',
			name: 'Private Network',
		},
		{
			key: 'locations',
			name: 'By Locations',
		},
		...(posthog.isFeatureEnabled(COMPLIANCE_FEATURE_FLAG)
			? [
					{
						key: 'compliance',
						name: 'Compliance Suite',
					},
			  ]
			: []),
		...(isNotSupplierManaged
			? [
					{
						key: 'wrenchhub',
						name: 'WrenchHub',
						accessPermissionName: PERMISSION_NAMES.MODIFY_SUPPLIERS,
					},
			  ]
			: []),
	];

	return (
		<>
			<Route
				path={`/${userType}/suppliers/overview`}
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/${userType}/suppliers/overview/privateNetwork`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Service Providers"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="suppliersPage"
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const ComponentWithoutUserType = withRouter(connect(mapStateToProps)(SuppliersOverviewPage));

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
